var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade-transition","mode":"out-in"}},[_c('div',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.isSelected),expression:"isSelected"}],ref:"content",class:[[_vm.className], ( _obj = {}, _obj[_vm.activeClassName] = _vm.isSelected, _obj )],attrs:{"tabindex":"-1"}},'div',_vm.$attrs,false),[(_vm.isActive)?_vm._t("default"):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }